import Collapse from '@material-ui/core/Collapse'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import { ChevronRight, ExpandMore } from '@material-ui/icons'
import _ from 'lodash'
import { PureComponent } from 'react'

import FormSubHeading from '../Headings/FormSubHeading'

const styles = () => ({
  icon: {
    alignItems: 'center',
    verticalAlign: 'middle',
    display: 'flex',
    '&:hover': {
      cursor: 'pointer',
    },
  },
})

class CollapsedRow extends PureComponent {
  state = { isOpen: false }

  render() {
    const { isOpen } = this.state
    const { title, children, classes } = this.props
    return (
      <Grid container>
        {!_.isEmpty(title) && (
          <Grid item xs={12}>
            <FormSubHeading
              noBottomBorder
              className={classes.icon}
              onClick={() => this.setState({ isOpen: !isOpen })}
              aria-label={isOpen ? 'Compress' : 'Expand'}
            >
              {isOpen ? <ExpandMore /> : <ChevronRight />}
              {title}
            </FormSubHeading>
          </Grid>
        )}
        <Grid item xs={12}>
          <Collapse in={isOpen}>{children}</Collapse>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(CollapsedRow)
